// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__29088","containerItemsCenter":"Skeleton_containerItemsCenter__3eHVX"};